/* --- File: src/components/AiLogo.js --- */
import React from 'react';
import logoData from './logo-ai.json'; // Đảm bảo bạn đã có file này

const AiLogo = ({ collapsed, size, fullSize }) => {
  // 1. Kích thước gốc của Logo trong thiết kế JSON
  const BASE_DESIGN_SIZE = 130;

  // 2. Xác định kích thước hiển thị
  let targetSize;
  if (fullSize) {
    targetSize = BASE_DESIGN_SIZE; // Nếu fullSize, dùng đúng 130px
  } else if (size) {
    targetSize = size; // Nếu truyền size cụ thể
  } else {
    targetSize = collapsed ? 40 : 50; // Mặc định cho Sidebar
  }

  // 3. Tính tỷ lệ scale
  const scale = fullSize ? 1 : targetSize / BASE_DESIGN_SIZE;

  // Style cho wrapper chứa HTML logo
  const scaledWrapperStyle = {
    width: BASE_DESIGN_SIZE,
    height: BASE_DESIGN_SIZE,
    transform: fullSize ? 'none' : `scale(${scale})`, // Không scale nếu là fullSize
    transformOrigin: 'center center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  // Style cho container giữ chỗ bên ngoài
  const placeholderStyle = {
    width: targetSize,
    height: targetSize,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // [QUAN TRỌNG] Nếu là fullSize thì cho phép hiển thị tràn ra ngoài (để thấy Badge AI)
    // Nếu ở Sidebar thì ẩn đi để gọn gàng
    overflow: fullSize ? 'visible' : 'hidden' 
  };

  // Inject CSS một lần duy nhất
  React.useEffect(() => {
    if (!document.getElementById('ai-logo-css')) {
      const styleTag = document.createElement('style');
      styleTag.id = 'ai-logo-css';
      styleTag.textContent = logoData.css;
      document.head.appendChild(styleTag);
    }
  }, []);

  const logoHtml = (
    <div style={placeholderStyle}>
      <div 
        style={scaledWrapperStyle}
        dangerouslySetInnerHTML={{ __html: logoData.html }} 
      />
    </div>
  );

  // Render cho trường hợp fullSize (Trang Login)
  if (fullSize) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', margin: '10px 0' }}>
        {logoHtml}
      </div>
    );
  }

  // Render cho trường hợp Sidebar
  return (
    <div style={{ 
      width: '100%', 
      padding: collapsed ? '10px 0' : '10px', 
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all 0.3s ease'
    }}>
      {collapsed ? (
        logoHtml
      ) : (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: 'white' }}>
          {logoHtml}
          {!size && (
            <span style={{ fontSize: '18px', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
              Coder's Den
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default AiLogo;